import { render } from "./My.vue?vue&type=template&id=215241c8&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=215241c8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-215241c8"

export default script